<template>
    <div>
        <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
            Aguarde! Atualizando ponto...<i class="pi pi-spin pi-spinner" ></i>
            <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
        </div>
        <IKFiltroFuncionarioContrato ref="ikFiltroFuncionarios"/>
		<div class="p-fluid p-formgrid p-grid p-mt-5">
            <div class="p-field p-col-12 p-md-12">
                <label>Justificativa</label>
                <Dropdown v-model.number="idJustificativaSelecionada" :options="justificativas" optionLabel="descricao" 
                    optionValue="id" dataKey="id" :filter="true" placeholder="Selecione"/>
            </div>                      
        </div>
        <h6 class="p-text-bold">Horário</h6>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-1">
                <label>1ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada1" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada1')"/>				
            </div>
            <div class="p-field p-col-12 p-md-1">
                <label>1ª Saída</label>
                <InputText v-model="horarioFlexivel.saida1" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida1')"/>		
            </div>
            <div class="p-field p-col-12 p-md-1">
                <label>2ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada2" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada2')"/>		
            </div>
            <div class="p-field p-col-12 p-md-1">
                <label>2ª Saída</label>
                <InputText v-model="horarioFlexivel.saida2" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida2')"/>		
            </div>
            <div class="p-field p-col-12 p-md-1">
                <label>3ª Entrada</label>
                <InputText v-model="horarioFlexivel.entrada3" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('entrada3')"/>		
            </div>
            <div class="p-field p-col-12 p-md-1">
                <label>3ª Saída</label>
                <InputText v-model="horarioFlexivel.saida3" maxlength="5" placeholder=":" class="p-text-center" 
                @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida('saida3')"/>		
            </div>  
        </div> 
        <h6 class="p-text-bold">Período</h6>  
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Data início</label>
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data final</label>
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
            </div>
        </div>
        <Button label="Salvar" icon="pi pi-check" class="p-mt-3" @click="salvar" v-if="permissaoNovo"/>
    </div>
</template>

<script>
import IKFiltroFuncionarioContrato from '@/components/template/IKFiltroFuncionarioContrato.vue';
import JustificativaService from '@/service/JustificativaService';
import MudancaHorarioService from '@/service/MudancaHorarioService';
import ControlePontoService from '@/service/ControlePontoService.js';
import HorarioFlexivel from '@/model/HorarioFlexivel';
import { exibirMensagem, exibirMensagemSis, formatarEtradaHora, localeCalendarBR} from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    mudancaHorarioService: null,    
    justificativaService: null,
	data() {
		return {
            permissaoNovo: false,
            horarioFlexivel: new HorarioFlexivel(),            		
            dataInicio: new Date(),
			dataFinal: new Date(),
			idJustificativaSelecionada: null,
			justificativas: [],
            localeCalendarBR: localeCalendarBR,
            progresso: 0,
            pararTimeout: false
		}
	},
	methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        /**
         * 
         */
        salvar() {          
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro();
            let funcionarios = dados.funcionarios;
            if(funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            if(this.idJustificativaSelecionada == null) {
                exibirMensagemSis(this, 'Selecione uma justificativa', true);
                return;
            }		
            if(this.horarioFlexivel.entrada1 == '' && this.horarioFlexivel.saida1 == ''
                && this.horarioFlexivel.entrada2 == '' && this.horarioFlexivel.saida2 == ''
                && this.horarioFlexivel.entrada3 == '' && this.horarioFlexivel.saida3 == '') {
                exibirMensagemSis(this, 'Configure um horário', true);
                return;
            }	
            let justificativa = null;
            for(let i = 0; i < this.justificativas.length; i++) {
                if(this.idJustificativaSelecionada == this.justificativas[i].id) {
                    justificativa = {...this.justificativas[i]};
                }
            }	   
            let funcios = [];
            funcionarios.forEach(f => {
                funcios.push({ id: f.id, nome: f.nome, pis: f.pis });
            });       	
            let hrFlex = {...this.horarioFlexivel};
            hrFlex.dia = this.formatarData(hrFlex.dia);
            let requisicao = {
                cnpj: {...dados.cnpj},
                funcionarios: funcios,
                justificativa: justificativa,
                horarioFlexivel: hrFlex,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.mudancaHorarioService.salvar(requisicao)
            .then(resp => {                
                this.horarioFlexivel = new HorarioFlexivel();
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                } 
                if(resp.data instanceof Array && resp.data.length > 0) {
                    this.atualizarPonto(resp.data);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		},
        /**
         * 
         */
         atualizarPonto(rangeDatas) {
            let dados = this.$refs.ikFiltroFuncionarios.getFiltro(); 
            this.$refs.ikFiltroFuncionarios.limparSelecionados();           
            let requisicoes = [];                   
            const fabricaRequisicoes = {
                criar: (range, dados) => {
                    return {
                        mes: range.mes,
                        ano: range.ano,
                        dataInicio: range.dataInicio,
                        dataFinal: range.dataFinal,
                        cnpj: dados.cnpj,
                        funcionarios: [],      
                        usuarioRequisicao: this.getDadosRequisicao(),          
                    };
                }
            }
            rangeDatas.forEach(range => {
                let requisicao = fabricaRequisicoes.criar(range, dados);
                requisicoes.push(requisicao);
                let qtd = 0;
                dados.funcionarios.forEach(funcio => {                
                    if(qtd < 5) {                        
                        qtd++;
                    } else {
                        qtd = 1;
                        requisicao = fabricaRequisicoes.criar(range, dados);
                        requisicoes.push(requisicao);
                    }
                    requisicao.funcionarios.push(funcio);
                }); 
            });                 
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.progresso = 1;             
            this.calcularPeriodoEditadoRecursivo(1, requisicoes);
        },
        /**
         * 
         */
        calcularPeriodoEditadoRecursivo(pagina, requisicoes) {    
            if(this.pararTimeout) {
                return;
            }       
            let requisicao = requisicoes[(pagina-1)];          
            this.controlePontoService.calcularPeriodoEditado2(requisicao, 'fdb=f')
            .then(()=>{
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    setTimeout(() => { this.progresso = 0; }, 1000);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.calcularPeriodoEditadoRecursivo(pagina, requisicoes);
                    }, 500);
                } 
            })
            .catch(erro => {                   
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
        },
        /**
         * 
         */
		listarJustificativas() {	
			this.justificativaService.listar({...this.getDadosRequisicao()})
            .then(resp => {
                this.justificativas = resp.data;                    
            })
            .catch(erro => {exibirMensagem(this, erro)});   
        },
        /**
         * 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        /**
         * 
         */
        limparEntradaHoraInvalida(campo) {
            if(this.horarioFlexivel[campo] == null) {
                return;
            }
            let regex = /[0-2][0-9]:[0-5][0-9]/g;
            if(!this.horarioFlexivel[campo].match(regex)) {
                this.horarioFlexivel[campo] = '';
            }
        },
        /**
         * 
         */
        validarEntraHora(event) {
            formatarEtradaHora(event);
        },
        /**
         * 
         */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(116);		
		}
	},
	created() {
        this.controlePontoService = new ControlePontoService();
        this.mudancaHorarioService = new MudancaHorarioService();        
		this.justificativaService = new JustificativaService();
	},
	mounted() {
        this.listarJustificativas();
        this.validarPermissoes();
	},
    beforeDestroy() {
        this.pararTimeout = true;
    },
	components: {
        'IKFiltroFuncionarioContrato': IKFiltroFuncionarioContrato,
    }
}
</script>

<style>

</style>